/* SCOPES */
export const SCOPE_GOOGLE_PHOTO = 'https://www.googleapis.com/auth/photospicker.mediaitems.readonly';
export const SCOPE_PROFILE = 'https://www.googleapis.com/auth/userinfo.profile';
export const SCOPE_EMAIL = 'https://www.googleapis.com/auth/userinfo.email';
/* ENDPOINTS */
export const OAUTH_2_ENDPOINT = 'https://accounts.google.com/o/oauth2/v2/auth';
export const SESSIONS_ENDPOINT = `https://photospicker.googleapis.com/v1/sessions`;
export const USER_INFO_ENDPOINT = 'https://www.googleapis.com/oauth2/v1/userinfo';
export const MEDIA_ITEMS_ENDPOINT = 'https://photospicker.googleapis.com/v1/mediaItems';
export const TOKEN_INFO_ENDPOINT = 'https://www.googleapis.com/oauth2/v1/tokeninfo';
